export default __webpack_public_path__ + "media/titles/title_4_locale_es-963f1e04.png";